import { render } from "./NavMenu.vue?vue&type=template&id=9b8e84c6&scoped=true"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"

import "./NavMenu.vue?vue&type=style&index=0&id=9b8e84c6&lang=scss&scoped=true"

import exportComponent from "E:\\4-6 项目\\蚂蚁电能交易分析\\energy\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b8e84c6"]])

export default __exports__